import { render, staticRenderFns } from "./CuentasBancarias.vue?vue&type=template&id=1f0ab598&lang=html&"
import script from "./CuentasBancarias.vue?vue&type=script&lang=js&"
export * from "./CuentasBancarias.vue?vue&type=script&lang=js&"
import style0 from "./CuentasBancarias.vue?vue&type=style&index=0&id=1f0ab598&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports